export enum EntityStatus {
    deleted = 'deleted',
    published = 'published',
    draft = 'draft'
}

